//@flow
import React from 'react';
import CustomerApiInterface from '../../APIInterfaces/customer';
import {AxiosResponse, AxiosError} from 'axios';
import _ from 'underscore';
import {FaQuoteLeft} from 'react-icons/fa';

type Testimonial = {
  author_name:string,
  statement:string,
};

type Props = {
  max?:number,
};
type State = {
  testimonials:Testimonial[],
};

export default class DelightedTestimonials extends React.Component<Props, State> {

  state = {
    testimonials: [],
  }

  componentDidMount() {
    CustomerApiInterface.getDelightedTestimonials()
      .then((response:AxiosResponse) => {
        const testimonials = response.data;
        if (!(testimonials && testimonials.length)) {
          return '';
        }
        const shuffled = _.shuffle(testimonials);
        // Because we are using an undocumented API for
        // fetching testimonials, add extra step of validation
        // so we know the data is correctly formatted
        const filtered = this.filterValidatedTestimonials(shuffled);
        return this.setState({
          testimonials: filtered,
        });
      })
      .catch((error:AxiosError) => {
      });
  }

  filterValidatedTestimonials = (testimonials:Testimonial[]):Testimonial[] => {
    return testimonials.filter((t:Testimonial) => {
      return Boolean(t.statement) && Boolean(t.author_name);
    });
  }

  getTestimonials():Testimonial[] {
    const {testimonials} = this.state;
    const max = this.props.max || 4;
    return (testimonials:Testimonial[]).slice(0, max);
  }

  renderTestimonials():React$Node[] {
    const testimonials:Testimonial[] = this.getTestimonials();
    return testimonials.map((t:Testimonial, index:number) => (
      <div className="testimonial-container" key={index}>
        <div className="quotation-mark-container">
          <FaQuoteLeft
            className="quotation-mark-icon"
          />
        </div>
        <div className="testimonial-text">
          {t.statement}
        </div>
        <div className="testimonial-author">
          {t.author_name}
        </div>
      </div>
    ));
  }

  render() {
    return (
      <div className="delighted-testimonials">
        {this.renderTestimonials()}
      </div>
    );
  }
}
